// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditModal_wrapper__2Y97q","footer":"EditModal_footer__14xmo"};